const I18N_EXTRAS = 'I18N_EXTRAS';

export const getI18nExtras = action => action[I18N_EXTRAS];

const actionDecoratorMiddlewareFactory = i18next => ({getState}) => next => action => {

  const state = getState();

  const t = i18next.t.bind(i18next);

  let decoratedAction = {
    ...action,
    [I18N_EXTRAS]: {
      appLanguage: state.app.language,
      dataLanguages: state.config.dataManagement.dataLanguages,
      t: t
    }
  }

  return next(decoratedAction);

};

export default actionDecoratorMiddlewareFactory;
